import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

import { CustomerComplianceType } from "./customer-compliance.model";

@Injectable({
	providedIn: "root",
})
export class CustomerComplianceConfig {
	private readonly countryComplianceCodes: Record<string, CustomerComplianceType> = {
		NL: "Dutch",
		AN: "Dutch",
	};

	private readonly countryComplianceDelay: Partial<Record<CustomerComplianceType, number>> = {
		Dutch: 3000,
	};

	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getComplianceByCountryCode(countryCode: string): CustomerComplianceType | undefined {
		return (
			this.configService.get(
				(x) => x.core.customerCompliance.countryCodes,
				this.countryComplianceCodes
			) as Record<string, CustomerComplianceType>
		)[countryCode];
	}

	getCountryKycPollingDelay(countryCompliance: CustomerComplianceType): number | undefined {
		return this.configService.get<Partial<Record<CustomerComplianceType, number>>>(
			(x) => x.core.customerCompliance.countryDelay,
			this.countryComplianceDelay
		)[countryCompliance];
	}

	// todo: AOCC-1715 once kyc-actions.guard is moved to common, remove this and consume configuration from common
	getIsCustomerAssessmentsEnabled(): boolean {
		return this.configService.get((x) => x.core.customerCompliance!.areCustomerAssessmentsEnabled, false);
	}
}
